import {
  getHiddenProcessFileTypes,
  ifOneThenTrue,
  InternalFeatureEnum,
  isInternalFeatureEnabled as isInternalFeatureEnabledForRoles,
} from '@xeovision/shared';

export const useFeatureFlagsStore = defineStore('feature-flags-store', () => {
  const runtimeConfig = useRuntimeConfig();
  const authNStore = useAuthNStore();

  const modes = {
    modeTest: ifOneThenTrue(runtimeConfig.public.MODE_TEST),
    modeDebug: ifOneThenTrue(runtimeConfig.public.MODE_DEBUG),
  };

  const features = {
    featureAuthN: ifOneThenTrue(runtimeConfig.public.FEATURE_AUTHN),
    featureAuthZ: ifOneThenTrue(runtimeConfig.public.FEATURE_AUTHZ),
    featurePayments: ifOneThenTrue(runtimeConfig.public.FEATURE_PAYMENTS),
    featureLocalLoader: ifOneThenTrue(runtimeConfig.public.FEATURE_LOCAL_LOADER),
    featureMinimap: ifOneThenTrue(runtimeConfig.public.FEATURE_MINIMAP),
  };

  const experimental = {
    explorerGraph: runtimeConfig.public.FEATURE_EXPLORER_GRAPH !== '0',
  };

  // Role gated, see InternalFeatureEnum
  const hiddenProcessFileTypes = computed(() => getHiddenProcessFileTypes(authNStore.userRoles));

  function isInternalFeatureEnabled(feature: InternalFeatureEnum) {
    return isInternalFeatureEnabledForRoles(feature, authNStore.userRoles);
  }

  return {
    modes,
    features,
    experimental,
    hiddenProcessFileTypes,
    isInternalFeatureEnabled,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useFeatureFlagsStore, import.meta.hot));
}
